
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/integrations/overview",
      function () {
        return require("private-next-pages/integrations/overview.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/integrations/overview"])
      });
    }
  